/* eslint-disable
    eqeqeq,
*/

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { firstPartyPluginsOrg, pluginCiOrg, environment } from '@trello/config';
import { makeErrorEnum } from 'app/scripts/lib/make-error-enum';
import { Plugin } from 'app/scripts/models/Plugin';
import { PluginHandlers } from 'app/scripts/views/internal/plugins/PluginHandlers';
import { PluginIO } from 'app/scripts/views/internal/plugins/PluginIo';

const PluginIOCacheError = makeErrorEnum('PluginCache', ['InvalidArgument']);

class PluginIOCache {
  static initClass() {
    this.prototype.Error = PluginIOCacheError;
  }

  constructor() {
    this.pluginFromId = {};
  }

  get(plugin) {
    let existingPlugin;
    if (!(plugin instanceof Plugin)) {
      throw PluginIOCacheError.InvalidArgument('expected a plugin');
    }

    const { id } = plugin;
    if ((existingPlugin = this.fromId(id)) != null) {
      return existingPlugin;
    }

    const iframeConnectorUrl = plugin.get('iframeConnectorUrl') ?? '';
    let iframeConnectorHost = '';
    try {
      iframeConnectorHost = new URL(iframeConnectorUrl).host;
    } catch (err) {
      // unable to parse connector url, odd
    }

    const idOrganizationOwner = plugin.get('idOrganizationOwner');
    const ownedByTrello = [firstPartyPluginsOrg, pluginCiOrg].includes(
      idOrganizationOwner,
    );
    const isDevPluginOnAtlasTunnel =
      environment !== 'prod' &&
      iframeConnectorHost.endsWith('.public.atlastunnel.com');

    const allowedOrigins = [
      '*.trello.services',
      environment !== 'prod' && '*.public.atlastunnel.com',
      'app.butlerfortrello.com',
      'butlerfortrello.com',
      'trellegi.services.atlassian.com',
      'trellegi.stg.services.atlassian.com',
      // This is Slack integration https://bitbucket.org/atlassian/trello-slack/src/main/power-up/
      'trello-slack.services.atlassian.com',
      'trello-slack.stg.services.atlassian.com',
    ].filter(Boolean);

    const isOnAllowedOrigin =
      iframeConnectorUrl.startsWith('https://') &&
      allowedOrigins.some((hostTest) =>
        hostTest.startsWith('*.')
          ? iframeConnectorHost.endsWith(hostTest.substring(1))
          : iframeConnectorHost === hostTest,
      );

    // Only in the dev environment is the first party plugins org 000000000000000000000000
    // checking this lets us capture localhost dev usage but also ngrok usage
    const isDevPluginsOrg = /^0{24}$/.test(firstPartyPluginsOrg);

    const canUseRestrictedHandlers =
      (ownedByTrello || isDevPluginOnAtlasTunnel) &&
      (isOnAllowedOrigin || isDevPluginsOrg);

    const io = new PluginIO(
      plugin,
      PluginHandlers({
        idPlugin: id,
        allowRestricted: canUseRestrictedHandlers,
      }),
    );

    this.pluginFromId[id] = io;
    return io;
  }

  fromId(id) {
    return this.pluginFromId[id];
  }

  drop(idPlugin) {
    let plugin;
    if ((plugin = this.pluginFromId[idPlugin]) != null) {
      delete this.pluginFromId[idPlugin];
      return plugin.drop();
    }
  }
}

PluginIOCache.initClass();
const pluginIOCache = new PluginIOCache();

export { pluginIOCache };
